import React, { useEffect, useState } from 'react';
import PlaceholderBlock from 'components/placeholder-blocks/PlaceholderBlock';
import CommonItemInfo from 'components/common-item/CommonItemInfo';
import { useDispatch } from 'react-redux';
import { setactiveItem } from 'store/cards';
import useActiveItem from 'hooks/useActiveItem';

const TournamentSelect = ({ 
  items, 
  activeSlot, 
  selectItemHandler, 
  playSound 
}) => {
  const { activeItem } = useActiveItem();
  const dispatch = useDispatch();
  const [filteredItems, setFilteredItems] = useState([]);

  const clickOnceHandler = (item) => {
    dispatch(setactiveItem(item));
    if (playSound) playSound('main');
  };

  const doubleClickHandler = (item) => {
    selectItemHandler(item);
    if (playSound) playSound('craftSelectItem');
  };

  useEffect(() => {
    setFilteredItems(items);
  }, [items, activeSlot]);

  return (
    <section className="craft-select">
      <h2 className="craft-block__title">
        Select {activeSlot}
      </h2>

      {activeSlot === 'TPC Wager' && (
        <h3 className="craft-block__title-visible-help">
          You can buy more Tournament Prize Cards from the Buy Packs page.
        </h3>
      )}

      {!filteredItems.length ? (
        <PlaceholderBlock />
      ) : (
        <ul className="cards-list__block cards-list__block--min">
          {filteredItems.map((item) => (
            <li
              className={`cards-list__block-item ${
                activeItem === item ? 'active' : ''
              }`}
              key={item.id}
              onClick={() => clickOnceHandler(item)}
              onDoubleClick={() => doubleClickHandler(item)}
            >
              <CommonItemInfo 
                name={item.name} 
                type={item.type} 
                image={item.image} 
                props={item.properties} 
              />
              <p className="cards-list__block-item-text">
                {item.type && item.type.toLowerCase() === 'tpc wager' ? '$' + item.name : item.name}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default TournamentSelect;
